import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'
import { Component } from 'react'
import { jsonClone, randomString } from '@/utils/helpers.jsx'
import { useLocation } from 'react-router-dom'

export type Tab = {
    id: string
    path: string
    label: string
    icon?: string | Component
    iconSize?: number
    data: any
    fixed: boolean
    //
    new: boolean
    place: 0,
}

export type TabsState = {
    currentTab?: Tab
    tabs: Tab[]
}

export const initialState: TabsState = {
    currentTab: undefined,
    tabs: []
}

export const tabsSlice = createSlice({
    name: `${SLICE_BASE_NAME}/tabs`,
    initialState,
    reducers: {
        setCurrentTab: (state, action: PayloadAction<Tab>) => {
            state.currentTab = action.payload
        },
        openTab: (state, action: PayloadAction<Tab>) => {
            let tab = state.tabs.find(tab => tab.path == action.payload.path)
            if (action.payload.new || !tab) {
                tab = {
                    ...action.payload,
                    id: `tab-${randomString(16)}`
                    // id: tabs.length + 1,
                    // icon: getIconIdentifier(action.payload.icon),
                }
                if (tab.place == 0)
                    state.tabs.unshift(tab)
                else
                    state.tabs.push(tab)
            }

            state.currentTab = tab
            // tabsSlice.actions.refreshTab(tab.id);
        },
        closeTab: (state, action: PayloadAction<string>) => {
            let tabIndex = state.tabs.findIndex(tab => tab.id === action.payload)
            let tab = state.tabs[tabIndex]
            if (!tab || tab.fixed) return

            state.tabs = state.tabs.filter(tab => tab.id !== action.payload)

            if (state.currentTab?.id == tab.id) {
                // console.log(nextTab)
                const nextTabIndex = Math.max(0, tabIndex - 1)
                if (nextTabIndex < 0 || state.tabs.length <= 0) {
                    state.currentTab = undefined
                    window.history.pushState(null, '', '/')
                    return
                }
                state.currentTab = state.tabs[nextTabIndex]
                window.history.pushState(null, '', state.currentTab?.path)
            }

        },
        closeAllTabs: (state) => {
            state.tabs = state.tabs.filter(tab => tab.fixed)
            state.currentTab = state.tabs[0]

            window.history.pushState(null, '', state.currentTab?.path)
        },
        selectTab: (state, action: PayloadAction<string>) => {
            const tab = state.tabs.find(tab => tab.id === action.payload)
            if (!tab) return
            // window.history.pushState(null, '', tab?.path);
            state.currentTab = tab
        },
        refreshTab: (state, action: PayloadAction<string>) => {
            const tab = state.tabs.find(tab => tab.id === action.payload)
            if (!tab) return
            const tabPath = tab?.path
            location.pathname = '/'
            // console.log(tab?.path)
            // const url = new URL(`${window.location.origin}${tab?.path}`);
            // url.search = 'r'; // e.g., "?r"
            // window.history.pushState({}, '', url);
            // setTimeout(()=>window.history.pushState(null, '', tabPath), 1000)
            // window.history.pushState(null, '', tab?.path);
            // window.history.pushState(null, '', tab?.path);
        },
        // setTabContent: (state, action: PayloadAction<any>) => {
        //     const tab = state.tabs.find(tab => tab.id === action.payload);
        //     if (!tab) return;
        //     tab.content = action.payload;
        // },
        setTabData: (state, action: PayloadAction<any>) => {
            const tab = state.tabs.find(tab => tab.id === state.currentTab?.id)
            if (!tab) return
            tab.data = action.payload
        }
    }
})

export const {
    setCurrentTab,
    openTab,
    closeTab,
    closeAllTabs,
    selectTab,
    refreshTab,
    setTabData
} = tabsSlice.actions

export default tabsSlice.reducer
